/** One PCM contract for daemon admission and browser capture. */
export const VOICE_SAMPLE_RATE = 24_000;
/** Exact silence for playback activity, never conversational turn detection. */
export function pcm16HasSignal(frame) {
  for (const byte of frame) if (byte !== 0) return true;
  return false;
}
